import { render, staticRenderFns } from "./CommonStudiesTab.vue?vue&type=template&id=945d04d0&scoped=true&"
import script from "./CommonStudiesTab.vue?vue&type=script&lang=js&"
export * from "./CommonStudiesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945d04d0",
  null
  
)

export default component.exports